<ng-template #attente>
  <br />
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
<div *ngIf="enregistrementTerminer; else attente"></div>
<mat-tab-group
  [selectedIndex]="indexActiveTabs"
  (selectedIndexChange)="indexActiveTabs = $event"
  class="biggest-container"
>
  <!-- --------------Lien principal---------------------- -->
  <mat-tab label="Image">
    <div class="display-flex">
      <div class="img-lienprincipale" (click)="openWindowSelectImage()">
        <img
          id="img-lien-principal"
          [src]="imgLienPrincipal.File_Content"
          width="100%"
          height="450px"
        />
      </div>
      <div class="text-lienprincipale">
        <div class="display-flex2">
          <h4>Français</h4>
          <button
            [disabled]="!enregistrementTerminer"
            type="button"
            (click)="
              enregistrerLangue(
                imgLienPrincipal,
                imgLienPrincipal.File_Text,
                imgLienPrincipalTextAnglais
              )
            "
            mat-raised-button
            class="colorGreen"
          >
            Enregistrer
          </button>
        </div>

        <angular-editor
          [config]="editorConfig"
          name="text1"
          placeholder=" "
          [(ngModel)]="imgLienPrincipal.File_Text"
        >
        </angular-editor>
        <h4>Anglais</h4>
        <angular-editor
          [config]="editorConfig"
          name="tex2"
          placeholder=" "
          [(ngModel)]="imgLienPrincipalTextAnglais"
        >
        </angular-editor>
      </div>
    </div>
  </mat-tab>
  <!-- --------------Lien en mosaique défilent---------------------- -->
  <!-- <mat-tab label="Blogues">
    <div class="display-flex" >
       <div (click)="showListeImageMosaiqie('1')" id="LIEN-MOSAIQUE-1" class="img-left">
        <div >Lien en mosaique 1</div>
      </div> 
        <div (click)="showListeImageMosaiqie('2')" id="LIEN-MOSAIQUE-2" class="img-right"><div>Manuel d'entretien</div></div>
        <div (click)="showListeImageMosaiqie('3')" id="LIEN-MOSAIQUE-3" class="img-right"><div>Guide pour bien choisir sa pointure</div></div>
        <div (click)="showListeImageMosaiqie('4')" id="LIEN-MOSAIQUE-4" class="img-right"><div>How we do it</div></div>
        <div (click)="showListeImageMosaiqie('5')" id="LIEN-MOSAIQUE-5" class="img-right"><div>Lien en mosaique 5</div></div>
    </div>
    <div class="display-flex" >
      <div class="width-liste">
        <app-liste 
            #listeLienMosaiqueComponen
            [showFilter]="false"
            [heightTable]="'400'"
            [displayedColumnsBrut]="columns"
            [listBtn]="listBtnLienMosaique"
            (btnTable)="clickBtnLienMosaique($event)">
        </app-liste>
      </div>
      <div class="text-lien-mosaique">
        <div class="display-flex2" >
          <h4>Français</h4>
          <button type="button" (click)="enregistrerLangue(selectedRow,imgLienMosaiqueTextFrancais,imgLienMosaiqueTextAnglais)" mat-raised-button class="colorGreen">Enregistrer</button>
        </div>
        
        <angular-editor [config]="editorConfig"
          name="text2"
          placeholder=" "
          [(ngModel)]="imgLienMosaiqueTextFrancais">
        </angular-editor>
        <h4>Anglais</h4>
        <angular-editor [config]="editorConfig"
          name="tex3"
          placeholder=" "
          [(ngModel)]="imgLienMosaiqueTextAnglais">
        </angular-editor>
      </div>
    </div>
   
  </mat-tab> -->
  <!-- --------------Lien et vidéo défilent---------------------- -->
  <mat-tab label="Vidéo défilent">
    <div class="display-flex">
      <div class="width-liste">
        <app-liste
          #listeLienEtVideoComponen
          [showFilter]="false"
          [heightTable]="'400'"
          [displayedColumnsBrut]="columns"
          [listBtn]="listBtnLienEtVideo"
          (btnTable)="clickBtnLienEtVideo($event)"
        >
        </app-liste>
      </div>

      <div class="text-lien-mosaique">
        <div class="display-flex2">
          <h4>Français</h4>
          <button
            type="button"
            [disabled]="!enregistrementTerminer"
            (click)="
              enregistrerLangue(
                selectedRow,
                imgLienEtVideoTextFrancais,
                imgLienEtVideoTextAnglais
              )
            "
            mat-raised-button
            class="colorGreen"
          >
            Enregistrer
          </button>
        </div>
        <mat-form-field class="width-100">
          <input
            matInput
            name="text4"
            [(ngModel)]="imgLienEtVideoTextFrancais"
            placeholder=""
          />
        </mat-form-field>

        <h4>Anglais</h4>
        <mat-form-field class="width-100">
          <input
            matInput
            name="text5"
            [(ngModel)]="imgLienEtVideoTextAnglais"
            placeholder=""
          />
        </mat-form-field>
        <!-- <mat-form-field class="width-100">
          <input matInputname="text5"
          placeholder=" "
          [(ngModel)]="imgLienEtVideoTextAnglais">
        </mat-form-field> -->
      </div>
    </div>

    <ng-template #content>
      <mat-dialog-content>
        <mat-form-field class="width-100">
          <input
            matInput
            name="video-link"
            [(ngModel)]="urlVideo"
            placeholder="Url video"
          />
        </mat-form-field>
        <mat-form-field class="width-100">
          <input
            matInput
            name="video-link"
            [(ngModel)]="titreVideo"
            placeholder="Titre"
          />
        </mat-form-field>
        <mat-form-field class="width-100">
          <input
            matInput
            name="video-link"
            [(ngModel)]="descriptionVideo"
            placeholder="Description"
          />
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button class="btn-red" mat-button mat-dialog-close>Annuler</button>
        <button class="btn-blue" mat-button (click)="ajouterVideo()">
          Ajouter
        </button>
      </mat-dialog-actions>
    </ng-template>
  </mat-tab>
</mat-tab-group>

<input
  id="input_file"
  type="file"
  value="importer"
  style="display: none"
  (change)="onChangeImagefile($event)"
/>
